<template>
    <div>
        <headers></headers>
        <div class="top-bg">

        </div>
        <caseDetail ref="caseDetail" v-if="type == 1"></caseDetail>
        <workResults ref="workResults" v-else-if="type == 2"></workResults>
        <studyDetail ref="studyDetail" v-else-if="type == 3"></studyDetail>
        <footers></footers>
    </div>
</template>
<script>
import headers from '@/components/header.vue'
import footers from '@/components/footer.vue'
import workResults from './components/detail/work_results.vue'
import caseDetail from './components/detail/case.vue'
import studyDetail from './components/detail/study.vue'
export default {
    components: { headers, footers, workResults, caseDetail, studyDetail },
    data() {
        return {
            id: null,
            detail: null,
            loading: false,
            type: 1
        }
    },
    created() {
        // this.id = this.$route.query.id
        this.type = this.$route.query.type
        // this.toDetail(this.$route.query.id);
    },
    methods: {
        toDetail(id) {
            // if (this.type == 0) {
            //     this.$refs.workResults.getDetail(id);
            // } else if (this.type == 1) {
            //     this.$refs.caseDetail.getDetail(id);
            // } else {
            //     this.$refs.studyDetail.getDetail(id);
            // }

        }
    }
}
</script>
<style>
body {
    background-color: #F4F4F4;
}

.top-bg {
    width: 100%;
    height: 324px;
    background-image: url('../../assets/images/article-bg.jpg');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.detail {
    width: 1200px;
    margin: 0 auto;
    margin-top: -240px;
    background-color: #fff;
}

.detail .content {
    margin: 0px 113px;
    padding: 64px 0;

}

.content-title {
    display: flex;
    align-items: center;
}

.content-title .title-line {
    width: 7px;
    height: 24px;
    background: #435696;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
}

.content-title .title {
    font-size: 24px;
    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
    font-weight: 600;
    color: #000000;
    margin-left: 6px;
    line-height: 19px;
}

.detail-img {
    width: 588px;
    height: 332px;
    border-radius: 13px 13px 13px 13px;
    opacity: 1;
}

.detail-content {
    margin-top: 30px;
}

.detail-content .title {
    width: 221px;
    font-size: 16px;
    font-weight: 600;
    color: #242627;
    line-height: 19px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.finish-time {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #838B93;
    line-height: 16px;
}

.d-data {
    margin-top: 24px;
    display: flex;
}

.eye img,
.download img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
}

.download {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #3D82F6;
    margin-left: 18px;
    display: flex;
    align-items: center;
}

.eye {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #E98510;
    display: flex;
    align-items: center;
}

.money .unit {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #297FFF;
    line-height: 20px;
}

.money .num {
    font-size: 24px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #297FFF;
    line-height: 28px;
}

.btn {
    /* margin-top: 72px; */
}

.btn img {
    width: 20px;
    height: 20px;
}

.btn .btn-type {
    display: flex;
    align-items: center;
}

.jianjie .title {
    font-size: 24px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #242627;
    line-height: 28px;
    margin: 48px 0 24px 0;
}

.jianjie .jianjie-content {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #242627;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/index/detail.vue